export class CheckinCheckoutHelper {
    static compareCurrentUser = (checkedOutUser: any, currentUsername: string): boolean => {
        try {
            const checkOutUserIdentity: string = (checkedOutUser.email ?? checkedOutUser.sip)?.trim();
            if (checkOutUserIdentity) {
                if (checkOutUserIdentity.toLowerCase() !== currentUsername?.trim()?.toLowerCase()) {
                    return false;
                }
            }
        } catch (error) {
            // Ignore
        }
        return true;
    };
}